import { render, staticRenderFns } from "./CollectionFeedbacks.vue?vue&type=template&id=3c28ed74&scoped=true"
import script from "./CollectionFeedbacks.vue?vue&type=script&lang=js"
export * from "./CollectionFeedbacks.vue?vue&type=script&lang=js"
import style0 from "./CollectionFeedbacks.vue?vue&type=style&index=0&id=3c28ed74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c28ed74",
  null
  
)

export default component.exports